import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { useSubscription } from '@/hooks/useSubscription';
import { useIsOwner } from '@/hooks/useIsOwner';

export default function SubscriptionBanner() {
    const { t } = useTranslation();
    const subscription = useSubscription();
    const isOwner = useIsOwner();

    if (isOwner || !subscription) {
        return null;
    }

    const trialEnding =
        subscription.status === 'trial' &&
        subscription.days_remaining != null &&
        subscription.days_remaining <= 7;

    const expired = subscription.is_active === false;

    if (!trialEnding && !expired) {
        return null;
    }

    return (
        <div
            className={`mx-4 mb-4 flex items-center gap-3 rounded-lg px-4 py-3 text-sm ${
                expired ? 'bg-red-50 text-red-800' : 'bg-amber-50 text-amber-900'
            }`}
        >
            <AlertTriangle className="h-5 w-5 shrink-0" />
            <p>
                {expired
                    ? t('subscription_expired_banner')
                    : t('subscription_trial_banner', { days: subscription.days_remaining })}
            </p>
        </div>
    );
}
